<app-navbar-style-one></app-navbar-style-one>

<div class="error-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="error-content">
                <img src="assets/img/logo/logo.png" width="180" alt="Images">
                <h1>4 <span>0</span> 4</h1>
                <h3>عفواً! لم يتم العثور على الصفحة</h3>
                <p>ربما تمت إزالة الصفحة التي تبحث عنها إذا تم تغيير اسمها أو أنها غير متاحة مؤقتًا.</p>
                <a routerLink="/" class="default-btn">العودة إلى الصفحة الرئيسية</a>
            </div>
        </div>
    </div>
</div>